module.exports = __webpack_public_path__ + "8a5356e9/img/boston-lights.a623432f.png";